document.addEventListener("DOMContentLoaded", function () {
  const mainTitle = document.querySelector(".video-gallery__title");
  const mainDate = document.querySelector(".video-gallery__date");
  const mainDescription = document.querySelector(".video-gallery__description");
  const mainMedia = document.querySelector(".video-gallery__main-hero");

  // Exit early if no main media
  if (!mainMedia) return;

  // Handle episode click to swap with main video
  document.querySelectorAll(".video-gallery__episode").forEach((block) => {
    block.addEventListener("click", () => {
      const episodeTitle = block.dataset.title || "";
      const episodeDate = block.dataset.date || "";
      const episodeDescription = block.dataset.description || "";
      
      // Get the video elements
      const mainVideoWrapper = document.querySelector(".video-gallery__main-hero");
      const episodeVideoWrapper = block.querySelector(".video-gallery__episode-media");
      
      if (!mainVideoWrapper || !episodeVideoWrapper) return;

      // Store current main data
      const mainData = {
        title: mainTitle?.textContent || "",
        date: mainDate?.textContent || "",
        description: mainDescription?.textContent || "",
        videoHTML: mainVideoWrapper.innerHTML
      };
      
      const episodeData = {
        title: episodeTitle,
        date: episodeDate,
        description: episodeDescription,
        videoHTML: episodeVideoWrapper.innerHTML
      };

      // Swap video HTML
      mainVideoWrapper.innerHTML = episodeData.videoHTML;
      episodeVideoWrapper.innerHTML = mainData.videoHTML;

      // Update text
      if (mainTitle) mainTitle.textContent = episodeData.title;
      if (mainDate) mainDate.textContent = episodeData.date;
      if (mainDescription) mainDescription.textContent = episodeData.description;

      // Update episode card text
      const epTitleNode = block.querySelector(".video-gallery__episode-title");
      if (epTitleNode) epTitleNode.textContent = mainData.title;
      const epDateNode = block.querySelector(".video-gallery__episode-date");
      if (epDateNode) epDateNode.textContent = mainData.date;

      // Update data attributes
      block.dataset.title = mainData.title;
      block.dataset.date = mainData.date;
      block.dataset.description = mainData.description;

      // Smooth scroll
      mainMedia.scrollIntoView({ behavior: "smooth" });
    });
  });

  // Initialize Swiper for episodes
  if (document.querySelector('.episode-swiper')) {
    const episodeSwiper = new Swiper('.episode-swiper', {
      slidesPerView: 1.2,
      spaceBetween: 24,
      centeredSlides: true,
      grabCursor: true,
      loop: false,
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    });
  }
});
